import React from 'react';
import { UncontrolledAlert } from 'seduo-ui';
function AlertExample() {
    return <UncontrolledAlert color="info">I am an alert and I can be dismissed!</UncontrolledAlert>;
}
export default AlertExample;
